import React from "react"
import { cn } from "../../../../../../lib"
import { Loader2 } from "lucide-react"
const Button = ({
  color = "second",
  size = "md",
  rounded = "md",
  className,
  type = "button",
  children = "Button",
  isLoading = false,
  disabled,
  ...props
}) => {
  const roundeds = {
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    full: "rounded-full",
  }

  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-base",
    lg: "px-5 py-[12px] text-lg",
  }

  const colors = {
    one: "bg-green-600 text-white hover:bg-green-700",
    second: "bg-second-success text-white hover:bg-success",
    third: "bg-white text-black hover:bg-gray-100",
  }

  return (
    <button
      type={type}
      disabled={isLoading || disabled}
      className={cn(
        "relative inline-flex items-center justify-center gap-2 cursor-pointer transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed",
        roundeds[rounded],
        sizes[size],
        colors[color],
        className
      )}
      {...props}
    >
      {isLoading && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </button>
  )
}

export default Button
